<template lang="pug">
.__input_field
  label.label {{ $attrs.name }}
  van-field(
    v-bind="$attrs"
    v-on="$listeners"
    readonly
    clickable
    :value="value"
    :disabled="disabled"
    @click="showPicker = true"
  )

  van-popup(v-if="!disabled" v-model="showPicker" position="bottom")
    van-datetime-picker(
      type="date"
      :min-date="new Date(minDate)"
      :max-date="new Date(maxDate)"
      @confirm="onTimeConfirm"
      @cancel="showPicker = false"
    )</template>

<script>
import dayjs from 'dayjs'

export default {
  props: {
    value: [Number, String],
    isTab: Boolean,
    disabled: Boolean
  },

  watch: {
    isTab: {
      handler(val) {
        if (val) {
          this.minDate = dayjs.tz().format('YYYY-MM-DD')
          this.maxDate = dayjs.tz().add(30, 'day').format('YYYY-MM-DD')
        }
      },
      immediate: true
    }
  },

  data() {
    return {
      showPicker: false,
      minDate: dayjs.tz().subtract(10, 'year').format('YYYY-MM-DD'),
      maxDate: dayjs.tz().add(10, 'year').format('YYYY-MM-DD')
    }
  },

  methods: {
    onTimeConfirm(time) {
      this.$emit('input', dayjs(time).format('DD/MM/YYYY'))
      this.showPicker = false
    }
  },
}
</script>

<style lang="sass" scoped>
@use "./vant-field" as *
</style>